class LogoMarquee extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {    
    this.initSwiper();
  }
  
  initSwiper() {    
    this.logoSwiper = this.querySelector(".mySwiperLogo");
    if (!this.logoSwiper) return;

    this.swiper = new Swiper(this.logoSwiper, {
        slidesPerView:6,
        spaceBetween:72,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,          
        },
        loop:true,
        breakpoints: {
        0: {
          slidesPerView: 2.9,
          spaceBetween: 40,
          centeredSlides: true,
          
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 50,
        },
        1025: {
          slidesPerView: 6,
          spaceBetween: 72,
        },
      },
    });
  }
    
}

customElements.define('logo-marquee', LogoMarquee);
class JournalSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {    
    this.initSwiper();
  }
  
  initSwiper() {    
    this.journalSwiper = this.querySelector(".journalSwiper");
    if (!this.journalSwiper) return;

    this.swiper = new Swiper(this.journalSwiper, {
        slidesPerView:3,
        spaceBetween:44,
         pagination: {
          el: this.querySelector('.swiper-pagination.journal-pagination'),
          clickable: true,
        },
        breakpoints: {
        0: {
          slidesPerView: 1.5,
          spaceBetween: 17,
        },
        640:{
          slidesPerView:  2.5,
          spaceBetween: 20,
        },
        768: {
          slidesPerView:  3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 44,
        }       
      },
    });
  } 
}
customElements.define('journal-slider', JournalSlider);
class YouMaySwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {    
    this.initSwiper();
  }
  
  initSwiper() {    
    this.youMaySwiper = this.querySelector(".youMaySwiper");
    if (!this.youMaySwiper) return;

    this.swiper = new Swiper(this.youMaySwiper, {
      cssMode: true,
      slidesPerView: 2.1,
      spaceBetween: 15,
      navigation: {
        nextEl: this.querySelector(".swiper-button-next.custom-next"),
        prevEl: this.querySelector(".swiper-button-prev.custom-prev"),
      },
      pagination: {
        el: this.querySelector(".handle__card-pagination .swiper-pagination"),
        clickable: true,
      },
      mousewheel: true,
      keyboard: true,
      breakpoints: {
        0: {
          slidesPerView: 2.2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 14.41,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 14.41,
        },
        1025: {
         slidesPerView: 5,
          spaceBetween: 14.41,
        },
      },
    });
  }
    
}
customElements.define("you-may-swiper", YouMaySwiper); 
class LoadMoreButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.loadMoreBtn = this.querySelector("#loadMoreBtn");
    this.blogGrid = document.querySelector("#blogGrid");

    if (!this.loadMoreBtn || !this.blogGrid) return;

    this.loadMoreBtn.addEventListener("click", async () => {
      const nextUrl = this.loadMoreBtn.getAttribute("data-next-url");
      if (!nextUrl) return;

      this.loadMoreBtn.innerText = "Loading...";

      try {
        const response = await fetch(nextUrl);
        const text = await response.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(text, "text/html");

        console.log(doc, "check doc here");

        // new articles
        const newItems = doc.querySelectorAll("#blogGrid .blog__card-col");

        newItems.forEach((item) => {
          this.blogGrid.appendChild(item);
        });

        // next button
        const newNextBtn = doc.querySelector("#loadMoreBtn");

        if (newNextBtn) {
          this.loadMoreBtn.setAttribute(
            "data-next-url",
            newNextBtn.getAttribute("data-next-url")
          );
          this.loadMoreBtn.innerText = "Load more posts +";
        } else {
          this.loadMoreBtn.remove();
        }

      } catch (err) {
        console.error(err);
        this.loadMoreBtn.innerText = "Error loading";
      }
    });
  }
}
customElements.define("load-more-button", LoadMoreButton);
class BlogFilterDrawer extends HTMLElement {
  connectedCallback() {    
    this.drawer  = this.querySelector('[data-drawer]');
    this.overlay = this.querySelector('[data-overlay]');
    this.openBtn = this.querySelector('[data-open]');
    this.closeBtn = this.querySelector('[data-close]');    

    // bind taaki removeEventListener me same reference mile
    this._open  = this.open.bind(this);
    this._close = this.close.bind(this);
    this._onKeydown = (e) => { if (e.key === 'Escape') this.close(); };

    this.openBtn?.addEventListener('click', this._open);
    this.closeBtn?.addEventListener('click', this._close);
    this.overlay?.addEventListener('click', this._close);
    document.addEventListener('keydown', this._onKeydown);
  }

  disconnectedCallback() {
    // cleanup — warna document-level listener leak karega
    this.openBtn?.removeEventListener('click', this._open);
    this.closeBtn?.removeEventListener('click', this._close);
    this.overlay?.removeEventListener('click', this._close);
    document.removeEventListener('keydown', this._onKeydown);
    document.body.style.overflow = '';
  }

  open() {
    this.drawer?.classList.add('active');
    this.overlay?.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.drawer?.classList.remove('active');
    this.overlay?.classList.remove('active');
    document.body.style.overflow = '';
  }
}

customElements.define('blog-filter-drawer', BlogFilterDrawer);
const observer = new MutationObserver(() => {
  const popup = document.getElementById('sewp-engine-popup');

  const isOpen =
    popup &&
    getComputedStyle(popup).display !== 'none';

  document.body.classList.toggle('wishlist-open', isOpen);
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['style', 'class']
});